<ion-item [formGroup]="parent">
  <ion-datetime
    mode="ios"
    onchange="onChanges()"
    [id]="question.key"
    [formControlName]="question.key"
    [max]="question.max"
    [min]="question.min"
    [attr.disabled]="question.disabled"
    [attr.readonly]="question.readonly"
    [cancelText]="question.cancelText | translate"
    [doneText]="question.doneText | translate"
    >>
  </ion-datetime>
</ion-item>
